<template>
    <div v-show="loading_states.epos"> <!--alx e-pos -->
        <div class="row mb-3">

            <div class="col-xl-4 col-lg-8">
                <div class="form-group form-row">
                    <label class="col-xl-4 col-lg-3 col-form-label fs-12 pt-12">{{i18n('Number of ticket')}}:</label>
                    <div class="col-xl-8 col-lg-4">
                        <input @keypress="changeTicketNumber()" @keyup.enter="getTripByTicketId" class="form-control base_input" placeholder="1000000" type="text" v-model="ticket_id"/>
                    </div>
                </div>
            </div>

            <div class="col-xl-6 col-lg-8">

                <div v-show="loading_states.button_show">
                    <button @click="getTripByTicketId()" class="btn base_btn solid_blue waves-effect waves-light" type="submit">{{i18n('Check ticket')}}</button>
                </div>
            </div>

            <hr class="clearfix col-xl-11 col-lg-12">
            <div class="col-xl-4 col-lg-8">
                <div class="form-group form-row">
                    <label class="col-xl-4 col-lg-3 col-form-label fs-12 pt-12">{{i18n('Search by last name')}}:</label>
                    <div class="col-xl-8 col-lg-4">
                        <input class="form-control base_input" :placeholder="i18n('Surname')" type="text" v-model="search_passanger.fullname"/>
                    </div>
                </div>
            </div>

            <div class="col-xl-6 col-lg-8">
                <div>
                    <button @click="searchPassenger($event)" class="btn base_btn solid_blue waves-effect waves-light" type="submit">{{i18n('Search')}}</button>
                </div>
            </div>

        </div>

        <search-passangers :getTicketByPassenger="getTicketByPassenger" :passanger_fullname="search_passanger.fullname" :search="search_passanger.search"></search-passangers>

        <div :class="[success ? 'active' : 'hidden']" class="row">
            <div class="col-sm-6">
                <div class="table-responsive">
                    <table class="table table-striped table-hover mb-0">
                        <thead>
                        <tr>
                            <th scope="col">Тип билета</th>
                            <th scope="col">{{i18n('Ticket price')}}</th>
                            <th scope="col">Штраф</th>
                            <th scope="col">К возврату</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>{{ticket_data.privilege_name}}</td>
                            <td>{{ticket_data.ticket_price + ' сум'}}</td>
                            <td v-if="ticket_fine && return_type_percent">{{ticket_fine + ' сум' + ' (' + return_type_percent +'%)'}}</td>
                            <td v-else></td>
                            <td v-if="return_price">{{return_price + ' сум'}}</td>
                            <td v-else></td>
                        </tr>
                        </tbody>
                    </table>

                    <div :class="[return_type_before_status ? 'r-b-active' : 'hidden']" style="margin-top: 20px;">
                        <h5>Возврат по вине пассажира до ухода рейса</h5>
                        <table class="table table-striped table-hover mb-0">
                            <thead>
                            <tr>
                                <th scope="col">Время до ухода рейса</th>
                                <th scope="col">{{i18n('Fine (percentage)')}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>{{time_before}} часа</td>
                                <td>{{return_type_percent}} %</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div style="margin-top: 20px;">
                    <div class="form-group form-row col-md-11" v-show="loading_states.return_types_show">
                        <label class="col-xl-2 col-lg-3 col-form-label fs-12 pt-12">Вид возврата:</label>
                        <div class="col-xl-8 col-lg-7">
                            <select @change="returnTypeChange()" class="custom-select base_select" data-width="100%"
                                    id="return_type_selection" title="Something" v-model="return_type">
                                <option :disabled="true" :selected="true" :value="null">Выберите вид возврата</option>
                                <option :disabled="(time_before < 0 && parseInt(key) === 4)"
                                        :value="key" v-for="(item, key) in return_types">{{item}}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group form-row col-md-11" v-show="loading_states.return_types_show">
                        <label class="col-xl-2 col-lg-3 col-form-label fs-12 pt-12">Номер тел для подтверждения:</label>
                        <div class="col-xl-8 col-lg-7">
                            <phone-number :disabled="loading_states.sms_sending || smsCodeSent || disableEditPhoneOnReturnTicket" class-name="form-control base_input" placeholder="Номер клиента"
                                          v-model="returningPassengerPhone"></phone-number>
                        </div>
                    </div>
                    <div class="form-group form-row col-md-11" v-show="smsCodeSent">
                        <label class="col-xl-2 col-lg-3 col-form-label fs-12 pt-12">Код подтверждения:</label>
                        <div class="col-xl-8 col-lg-7">
                            <vue-regex-input :regExp="/^\d{0,6}$/g" class="form-control base_input" v-model="smsCode"></vue-regex-input>
                        </div>
                    </div>

                    <button :disabled="returningPassengerPhone.length !== 9" @click="sendSmsCode" class="btn base_btn solid_blue waves-effect waves-light float-right size192" type="submit"
                            v-show="return_type && !smsCodeSent">
                        <span aria-hidden="true"
                              class="spinner-grow spinner-grow-sm text-light" role="status"
                              v-if="loading_states.sms_sending"></span>
                        <span v-else>Отправить смс код</span>
                    </button>
                    <button
                            :disabled="!return_type || smsCode.length!==6 || loading_states.returning_ticket"
                            @click="returnTicket"
                            class="btn base_btn solid_blue waves-effect waves-light float-right size192"
                            v-show="smsCodeSent">
                        <span aria-hidden="true"
                              class="spinner-grow spinner-grow-sm text-light" role="status"
                              v-if="loading_states.returning_ticket"></span>
                        <span v-else>Возврат билета</span>
                    </button>
                </div>
                <div class="text-center pt-3 pb-3 border" style="margin-top:100px; border: none !important;" v-show="loading_states.list">
                    <i class="mdi mdi-spin mdi-loading"></i> {{i18n('Loading')}}...
                </div>
            </div>
            <div class="col-sm-6">
                <div class="jumbotron p-3 mb-3">
                    <table class="table fs-12 border-0 table-sm mb-0">
                        <tbody>
                        <tr>
                            <th class="w-25 border-0">Дата покупки билета:</th>
                            <td>{{ticket_data.ticket_sold_date}}</td>
                        </tr>
                        <tr>
                            <th class="w-25 border-0">{{i18n('Departure')}}:</th>
                            <td>{{ticket_data.departure_time}}</td>
                        </tr>
                        <tr>
                            <th class="w-25 border-0"></th>
                            <td>{{ticket_data.routes_from}}</td>
                        </tr>
                        <tr>
                            <th class="w-25 border-0">Прибытие:</th>
                            <td>{{ticket_data.arrival_time}}</td>
                        </tr>
                        <tr>
                            <th class="w-25 border-0"></th>
                            <td>{{ticket_data.routes_to}}</td>
                        </tr>
                        <tr>
                            <th class="w-25 border-0">{{i18n('Full name')}}:</th>
                            <td>{{ticket_data.passenger_name}}</td>
                        </tr>
                        <tr>
                            <th class="w-25 border-0">{{i18n('Place')}}:</th>
                            <td>{{ticket_data.place_number}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <p class="fs-12 gray">Без удерживаний <br>
                    Устав автотранспорта. Статья 23 п4: <br>
                    "Пассажир имеет право: ... возвратить билет в кассу до
                    отправления транспортного средства и получить обратно полную
                    стоимость проезда, <br>
                    перевозки багажа, провоза ручной клади в следующих случаях: <br>
                    а) отмена отправления транспортного средства; <br>
                    б) задержка отправления транспортного средства более чем на час;"</p>
            </div>
        </div>
        <div :class="[success ? 'hidden' : 'active']" class="row">
            <label class="col-xl-4 col-lg-3 col-form-label fs-12 pt-12"><h2>{{error_message}}</h2></label>
        </div>

    </div>
</template>

<script>
    import {ModelListSelect} from 'vue-search-select';
    import SearchPassangers from './SearchPassangers';
    import PhoneNumber from "../../components/PhoneNumber";
    import VueRegexInput from 'vue-regex-input';

    export default {
        name: "TicketReturn",
        components: {
            PhoneNumber,
            SearchPassangers,
            ModelListSelect,
            VueRegexInput
        },
        data() {
            return {
                ticket_data: {
                    arrival_time: null,
                    departure_time: null,
                    place_number: null,
                    routes_from: null,
                    routes_to: null,
                    ticket_sold_date: null,
                    trip_id: null,
                    ticket_price: null,
                    privilege_name: null,
                },
                smsCode: '',
                smsCodeSent: false,
                returningPassengerPhone: '',
                disableEditPhoneOnReturnTicket: true,
                ticket_id: null,
                return_price: '',
                ticket_fine: '',
                return_types: [],
                return_type: null,
                return_type_percent: '',
                return_type_before_status: false,
                time_before: 0,
                success: false,
                error_message: null,
                loading_states: {
                    list: false,
                    button_show: true,
                    return_types_show: false,
                    sms_sending: false,
                    returning_ticket: false,
                    epos: false //alx e-pos
                },
                unsuccessfull: false,

                search_passanger: {
                    fullname: null,
                    search: false
                },

                search_ticket_by_passenger: false,

                //alx e-pos
                epos: {
                    enabled: false,
                    url: 'http://localhost:8347/uzpos',
                    token: 'DXJFX32CN1296678504F2',
                    printer_size: 80,
                    device_id: null,
                    company_name: null,
                    company_address: null,
                    company_inn: null,
                    class_code_international: null,
                    package_code_international: null,
                    class_code_domestic: null,
                    package_code_domestic: null,
                    vat_percent: 0,
                    modules: null,
                },
            }
        },

        methods: {

            //alx e-pos
            get_epos_data() {
                this.loading_states.epos = false;
                let epos_data = {};
                this.$api.get('epos.data').then(res => {
                    epos_data = res.data;
                    if (epos_data.enabled) {
                        this.$http.post(epos_data.url, {
                            "token": epos_data.token,
                            "method": "getDeviceId",
                            }).then(res2 => {
                                if (res2.data.error) {
                                    if (res2.data.message) {
                                        this.errorMsg("E-POS: " + res2.data.message);
                                    }
                                    return false;
                                }
                                console.log("E-POS: DeviceId: ", res2.data.message);

                                this.epos.enabled = true;
                                this.epos.device_id = res2.data.message;
                                this.epos.url = epos_data.url;
                                this.epos.token = epos_data.token;
                                this.epos.printer_size = epos_data.printer_size;
                                this.epos.company_name = epos_data.company_name;
                                this.epos.company_address = epos_data.company_address;
                                this.epos.company_inn = epos_data.company_inn;
                                this.epos.class_code_international = epos_data.class_code_international;
                                this.epos.package_code_international = epos_data.package_code_international;
                                this.epos.class_code_domestic = epos_data.class_code_domestic;
                                this.epos.package_code_domestic = epos_data.package_code_domestic;
                                this.epos.vat_percent = epos_data.vat_percent;
                                this.epos.modules = epos_data.modules ? JSON.parse(epos_data.modules) : null;

                            }).catch((err) => {
                                this.errorMsg("E-POS: Невозможно получить данные! \n" + err);
                            }).finally(() => {
                                this.loading_states.epos = true;
                                console.log("E-POS: to server request getDeviceId complited!");
                            });
                    } else {
                        this.loading_states.epos = true;
                        console.log("E-POS: to server request getDeviceId complited!");
                    }
                });
            },
            process_epos_refund(ticket_id, return_price) {
                console.log("E-POS: epos_refund return_price: ", return_price);
                this.$api.get('epos.receipt', ticket_id)
                    .then(res => {
                        if (res.errors) {
                            this.errorMsg(res.errors);
                            this.returnTicketSuccess();
                            this.loading_states.returning_ticket = false;
                            return false;
                        }
                        //console.log(res.data);
                        if (!res.data) {
                            // Was NOT sold from an E-POS module
                            console.log("E-POS: The Ticket Was NOT sold from an E-POS module");
                            this.returnTicketSuccess();
                            this.loading_states.returning_ticket = false;
                            return false;
                        }

                        if (res.data.method === 0) {
                            // E-POS sell receipt method
                            let sold_epos_module_url = null;
                            if (res.data.device_id === this.epos.device_id) {
                                // This is the same cassier computer
                                console.log("E-POS: This receipt was sold from this fm");
                                sold_epos_module_url = this.epos.url;
                            } else {
                                console.log("E-POS: This receipt was sold from another fm: " + res.data.device_id);
                                this.successMsg("E-POS: Этот билет был продан с другого фискального модуля! \n" + res.data.device_id);
                                if (!this.epos.modules) {
                                    this.errorMsg("E-POS: Список фискальных модулей пуст!");
                                    this.returnTicketSuccess();
                                    this.loading_states.returning_ticket = false;
                                    return false;
                                }
                                //console.log(this.epos.modules);
                                for (let module of this.epos.modules) {
                                    //console.log(module.device_id);
                                    if (module.device_id === res.data.device_id) {
                                        //console.log(module.device_ip);
                                        if (module.device_ip) {
                                            console.log("E-POS: Найден IP фискального модуля продажи: " + module.device_ip);
                                            sold_epos_module_url = 'http://' + module.device_ip + ':8347/uzpos';
                                        }
                                    }
                                }
                                if (sold_epos_module_url === null) {
                                    this.errorMsg("E-POS: Не найден IP фискального модуля продажи!");
                                    this.returnTicketSuccess();
                                    this.loading_states.returning_ticket = false;
                                    return false;
                                }
                            }
                            this.epos_open_refund(sold_epos_module_url, res.data, return_price);
                        }
                    })
                    .catch(errors => {
                        this.errorMsg("E-POS: Данные не сохранены!\n " + errors);
                        this.returnTicketSuccess();
                        this.loading_states.returning_ticket = false;
                    })
                    .finally(() => {
                        console.log("E-POS: to server request epos.receipt complited!");
                    });
            },
            epos_open_refund(url, epos_receipt, return_price) {
                console.log("E-POS: epos_refund return_price: ", return_price);
                let method = "openZreport";
                this.$http.post(url, {
                        "token": this.epos.token,
                        "method": method
                    }).then(res2 => {
                        if (res2.data.error) {
                            if (res2.data.message) {
                                // Already opened
                                if ( res2.data.message !== ' EN: ERROR_ZREPORT_IS_ALREADY_OPEN \n Ru: Z отчет уже открыт' ) {
                                    this.errorMsg("E-POS: " + res2.data.message);
                                    this.returnTicketSuccess();
                                    this.loading_states.returning_ticket = false;
                                    return false;
                                }
                            }
                        } else {
                            this.successMsg("E-POS: Кассовая смена успешно открыта!\n" + url);
                        }
                        this.epos_refund(url, epos_receipt, return_price);

                    }).catch((err) => {
                        this.errorMsg("E-POS: Невозможно получить данные!\n" + url + "\n" + err);
                        this.returnTicketSuccess();
                        this.loading_states.returning_ticket = false;
                    }).finally(() => {
                        console.log("E-POS: to module request openZreport complited!");
                    })
            },
            epos_refund(url, epos_receipt, return_price) {
                console.log("E-POS: epos_refund return_price: ", return_price);

                let class_code = epos_receipt.trip_type === true ? this.epos.class_code_international : this.epos.class_code_domestic;
                let package_code = epos_receipt.trip_type === true ? this.epos.package_code_international : this.epos.package_code_domestic;

                let class_code_transporter = epos_receipt.transporter_class_code ? epos_receipt.transporter_class_code : class_code;
                let package_code_transporter = epos_receipt.transporter_package_code ? epos_receipt.transporter_package_code :  package_code;

                let owner_type = 2; // Тип владения товаром. 0-Перепродажа, 1-Производитель, 2-Услуга

                let commission_tin = epos_receipt.trip_type === true ? epos_receipt.transporter_inn : '200796104';

                let amount = 1 * 1000;

                let full_return_price = return_price * 100;

                let percent = parseInt(epos_receipt.transporter_percent);

                let price_transporter = Math.round((full_return_price / 100) * percent);
                let price_bus_station = full_return_price - price_transporter;

                let vat_percent_transporter = epos_receipt.transporter_vat_percent ? parseInt(epos_receipt.transporter_vat_percent) : 0;
                //let vat_transporter = Math.round((price_transporter / 100) * vat_percent_transporter);
                let vat_transporter = Math.round((price_transporter/(1+vat_percent_transporter/100)-price_transporter)*-1);

                let vat_percent_bus_station = this.epos.vat_percent ? parseInt(this.epos.vat_percent) : 0;
                //let vat_bus_station = Math.round((price_bus_station / 100) * vat_percent_bus_station);
                let vat_bus_station = Math.round((price_bus_station/(1+vat_percent_bus_station/100)-price_bus_station)*-1);

                this.$http.post(url, {
                    "token": this.epos.token,
                    "method": "refund",
                    "companyName": this.epos.company_name,
                    "companyAddress": this.epos.company_address,
                    "companyINN": this.epos.company_inn,
                    "staffName": epos_receipt.user.username, // Cashier Name
                    "printerSize": this.epos.printer_size,
                    "params": {
                        //"paycheckNumber": epos_receipt.order_id,
                        //"clientName": "Khamidov Iskander",
                        "note": "Возврат билета",
                        "items": [
                            {
                                "name": "Билет",
                                "discount": 0,
                                "price": price_transporter,
                                "amount": amount,
                                "vatPercent": vat_percent_transporter,
                                "vat": vat_transporter,
                                "classCode": class_code_transporter,
                                "packageCode": package_code_transporter,
                                "ownerType" : owner_type,
                                "commissionTIN": commission_tin
                            },
                            {
                                "name": "Услуга автовокзала",
                                "discount": 0,
                                "price": price_bus_station,
                                "amount": amount,
                                "vatPercent": vat_percent_bus_station,
                                "vat": vat_bus_station,
                                "classCode": class_code,
                                "packageCode": package_code,
                                "ownerType" : owner_type
                            }
                        ],
                        "receivedCash": epos_receipt.payment_type === 1 ? full_return_price : 0,
                        "receivedCard": epos_receipt.payment_type === 2 ? full_return_price : 0,
                    },
                    "refundInfo": {
                        "terminalId": epos_receipt.terminal_id,
                        "receiptSeq": epos_receipt.receipt_seq,
                        "dateTime": epos_receipt.date_time,
                        "fiscalSign": epos_receipt.fiscal_sign
                    }
                }).then(res2 => {
                    if (res2.data.error) {
                        if (res2.data.message) {
                            this.errorMsg("E-POS: " + res2.data.message);
                        }
                    } else {

                        // Add refund receipt to DB
                        /*
                        this.form.order_id = order_id;
                        this.form.epos['method'] = 1;
                        this.form.epos['deviceId'] = this.epos.device_id;
                        this.form.epos['terminalId'] = res2.data.info.terminalId;
                        this.form.epos['receiptSeq'] = res2.data.info.receiptSeq;
                        this.form.epos['fiscalSign'] = res2.data.info.fiscalSign;
                        this.form.epos['dateTime'] = res2.data.info.dateTime;

                        this.form.submit('post', this.route('api.epos.save-receipt'), false)
                            .then(res => {
                                if (res.errors) {
                                    this.errorMsg(res.errors);
                                }
                            })
                            .catch(errors => {
                                this.errorMsg("E-POS: Данные не сохранены!")
                            })
                            .finally(() => {
                            });
                        */

                    }

                }).catch((err) => {
                    this.errorMsg("E-POS: Данные не сохранены!\n" + err);

                }).finally(() => {
                    console.log("E-POS: to module request Refund complited!");
                    this.returnTicketSuccess();
                    this.loading_states.returning_ticket = false;
                })
            },
            successMsg(message) {
                if (_.isArray(message)) {
                    message.forEach(error => {
                        Vue.notify({
                            type: 'success',
                            group: 'foo',
                            title: '',
                            text: error.message
                        });
                    })
                } else {
                    Vue.notify({
                        type: 'success',
                        group: 'foo',
                        title: '',
                        text: message
                    });
                }
            },
            errorMsg(message) {
                if (_.isArray(message)) {
                    message.forEach(error => {
                        Vue.notify({
                            type: 'error',
                            group: 'foo',
                            title: '',
                            text: error.message,
                            duration: -1,
                        });
                    })
                } else {
                    Vue.notify({
                        type: 'error',
                        group: 'foo',
                        title: '',
                        text: message,
                        duration: -1,
                    });
                }
                console.log(message);
            },


            getTripByTicketId() {
                this.resetSms();
                if (this.unsuccessfull === true) {
                    return;
                }
                let postData = {};
                this.loading_states.list = true;

                this.ticket_id = parseInt(this.ticket_id);

                if (this.ticket_id > 0) {
                    postData.ticket_id = this.ticket_id;
                    this.$api.post('return-ticket.get-trip', postData).then(({data}) => {
                        if (data.success === false) {
                            this.error_message = data.message;
                            this.success = false;
                            this.unsuccessfull = true;
                        } else {
                            this.success = true;
                            this.ticket_data = data;
                            this.time_before = data.time_before;
                            this.loading_states.button_show = false;
                            this.loading_states.return_types_show = true;
                            this.returningPassengerPhone = data.passenger_phone || '';
                            this.returningPassengerId = data.passenger_id;
                            this.disableEditPhoneOnReturnTicket = this.returningPassengerPhone.length === 9;
                        }
                    }).finally(() => {
                        this.loading_states.list = false;
                    });
                } else {
                    this.error_message = null;
                    this.success = false;
                }
            },
            getReturnTypes() {
                this.$api.get('return-ticket.get-return-types').then(({data}) => {
                    this.return_types = data;
                }).finally(() => {
                    this.loading_states.list = false;
                });
            },
            getReturnTypePercent(type_id) {

                this.loading_states.list = true;
                let postData = {};
                postData.ticket_id = this.ticket_id;
                postData.type_id = type_id;
//alx TODO: Get departure_time  current_time on the server side
                postData.departure_time = new Date(this.ticket_data.departure_time).getTime();
                postData.current_time = new Date(Date.now()).getTime();
                //postData.ticket_price = this.ticket_data.ticket_price;

                this.$api.post('return-ticket.return-price', postData).then(({data}) => {
//alx FIX: calculate ticket fine on the server side!
                    if (data.success === false) {
                            this.error_message = data.message;
                            this.success = false;
                            this.unsuccessfull = true;
                    } else {
                        this.return_type_percent = data.percent;
                        this.time_before = data.time_before;
                        this.return_type_before_status = (data.before) ? data.before : false;
                        //this.ticket_fine = Math.floor((this.ticket_data.ticket_price / 100) * data.percent);
                        //this.return_price = Math.floor(this.ticket_data.ticket_price - this.ticket_fine);
                        this.ticket_fine = data.ticket_fine;
                        this.return_price = data.return_price;
                    }
                }).finally(() => {
                    this.loading_states.list = false;
                });
            },
            returnTypeChange() {
                this.getReturnTypePercent(parseInt(this.return_type));
            },
            returnTicket() {

                this.loading_states.returning_ticket = true;
                let postData = {};
                postData.ticket_id = this.ticket_id;
                postData.return_type = this.return_type;
                postData.return_price = this.return_price;
                postData.sms_code = this.smsCode;
                postData.phone = this.returningPassengerPhone;

                this.$api.post('return.return-ticket', postData).then(({data, errors}) => {
                    if (errors) {
                        this.$toast({
                            type: 'error',
                            title: 'Код подтверждения SMS неправильно'
                        });
                    } else {

                        //alx e-pos
                        if (this.epos.enabled) {
                            console.log("E-POS: epos_refund return_price: ", this.return_price);
                            this.process_epos_refund(this.ticket_id, this.return_price);
                        } else {
                            this.returnTicketSuccess();
                        }


                        /*
                        this.$toast({
                            type: 'success',
                            title: 'Билет был успешно возвращен!'
                        });

                        if (this.search_passanger.search) {
                            this.searchPassenger();
                        }

                        this.resetSms();
                        this.reloadItems();
                        */
                    }
                }).finally(() => {
                    if (!this.epos.enabled) {
                        this.loading_states.returning_ticket = false;
                    }
                });
            },
            returnTicketSuccess() {
                this.$toast({
                    type: 'success',
                    title: 'Билет был успешно возвращен!'
                });

                if (this.search_passanger.search) {
                    this.searchPassenger();
                }

                this.resetSms();
                this.reloadItems();
            },
            changeTicketNumber() {
                this.success = false;
                this.unsuccessfull = false;
                this.loading_states.list = false;
                this.loading_states.return_types_show = false;
                this.loading_states.button_show = true;
            },
            sendSmsCode() {
                this.loading_states.sms_sending = true;
                this.$api.post('return.send-verification-code', {
                    number: this.returningPassengerPhone,
                    passenger_id: this.returningPassengerId,
                    //percent: this.return_type_percent
                    //alx
                    return_price: this.return_price
                }).then(res => {
                    this.smsCode = '';
                    if (res.errors) {
                        this.$toast({
                            type: 'error',
                            title: 'SMS не отправлено на (' + this.returningPassengerLongPhone + ')'
                        });
                    } else {
                        this.smsCodeSent = true;
                        this.$toast({
                            type: 'success',
                            title: 'Код подтверждения отправлено на (' + this.returningPassengerLongPhone + ')'
                        });
                    }
                }).catch().finally(() => {
                    this.loading_states.sms_sending = false;
                });
            },
            searchPassenger(event) {
                this.resetSms();
                this.reloadItems();
                this.search_passanger.search = false;
                setTimeout(() => {
                    this.search_passanger.search = true
                }, 10)
            },
            getTicketByPassenger(ticket) {
                this.ticket_id = ticket;
                this.unsuccessfull = false;
                this.getTripByTicketId();
            },
            resetSms() {
                this.smsCodeSent = false;
                this.smsCode = '';
            },
            reloadItems() {
                this.loading_states.list = false;
                this.ticket_id = null;
                this.return_price = '';
                this.ticket_fine = ''; //alx
                this.return_type = null;
                this.success = false;
                this.loading_states.button_show = true;
                this.loading_states.return_types_show = false;
                this.unsuccessfull = false;
                this.error_message = null;
                if (this.search_ticket_by_passenger) {
                    this.searchPassenger()
                }
            }
        },
        computed: {
            returningPassengerLongPhone() {
                return '+998' + this.returningPassengerPhone;
            }
        },
        watch: {
            return_type_percent() {
                this.smsCodeSent = false
            },
        },
        created() {
            this.getReturnTypes();
            //alx e-pos
            this.get_epos_data();

        },
    }
</script>

<style scoped>
    .active {
        display: flex;
    }

    .hidden {
        display: none;
    }

    .r-b-active {
        display: flex;
    }

    .size192 {
        width: 192px;
    }
</style>
